export const environment = {
  production: false,
  env: 'stg',
  version: 'stg-af4c6e6f',
  feedbackDelay: 5000,
  api: 'https://stg.api.roz.copec.cl',
};
